import React from 'react'

export default () => {

    // return <HSpinner size="" />

    return (
        <>
            <div data-testid="test-spinner" className="fadeMe items-center justify-center text-center flex h-screen">
                {/* <HSpinner size="sm" /> */}
                {/* <HButton ariaLabel="Submit" btntype="submit" disabled="false" href="https://google.com" rounded="true" size="lg" variation="primary" > Submit </HButton> */}
                <span className="loader h-6 w-6 items-center justify-center text-center absolute ml-3" ></span>
            </div>
        </>
    )
}
